// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__GT+UN","content":"modal_content__p6i4A","title":"modal_title__bkogG","closeBtn":"modal_closeBtn__h0the","bg":"modal_bg__RMZHQ"};